<template>
    <div>
        <div v-if="loading">{{translate('imzalayici.imzalayiciVersionChecking')}}</div>
        <div class="spinner-container" v-if="loading">
            <div class="spinner" ></div>
        </div>
        <ImzalayiciV1
        v-if="isImzalayiciV1"
        ref="imzalayiciv1"
        :items="items"
        :autoSubmit="autoSubmit"
        :identityNumber="identityNumber"
        :processingMessage="processingMessage"
        :showFileList="showFileList"
        :userCertificateUrl="userCertificateUrl"
        :InitData="InitData"
        @modechange="modechange"
        @completed="completed"
        ></ImzalayiciV1>
        <ImzalayiciV2
        v-if="isImzalayiciV2"
        ref="imzalayiciv2"
        :autoSubmit="autoSubmit"
        :items="items"
        :identityNumber="identityNumber"
        :processingMessage="processingMessage"
        :showFileList="showFileList"
        :userCertificateUrl="userCertificateUrl"
        :certificateType="certificateType"
        :InitData="InitData"
        @modechange="modechange"
        @completed="completed"

        ></ImzalayiciV2>
        <div v-else-if="imzalayiciNotFound" class="text-center" style="padding-top:30px;">
            <div style="padding:30px 0px;">{{translate('imzalayici.imzalayiciCantFound')}}</div>
            <div>
                <button type="button" class="btn btn-primary" @click="check">{{translate('tryAgain')}}</button>
                <div class="downloadButtons">
                        <a class="btn btn-link mt-3 downloadButton" href="https://www.izometri.com.tr/imzalayici/imzalayiciSetup.exe"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-60.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M13.1458647,7289.43426 C13.1508772,7291.43316 13.1568922,7294.82929 13.1619048,7297.46884 C16.7759398,7297.95757 20.3899749,7298.4613 23.997995,7299 C23.997995,7295.84873 24.002005,7292.71146 23.997995,7289.71311 C20.3809524,7289.71311 16.7649123,7289.43426 13.1458647,7289.43426 M4,7289.43526 L4,7296.22153 C6.72581454,7296.58933 9.45162907,7296.94113 12.1724311,7297.34291 C12.1774436,7294.71736 12.1704261,7292.0908 12.1704261,7289.46524 C9.44661654,7289.47024 6.72380952,7289.42627 4,7289.43526 M4,7281.84344 L4,7288.61071 C6.72581454,7288.61771 9.45162907,7288.57673 12.1774436,7288.57973 C12.1754386,7285.96017 12.1754386,7283.34361 12.1724311,7280.72405 C9.44461153,7281.06486 6.71679198,7281.42567 4,7281.84344 M24,7288.47179 C20.3879699,7288.48578 16.7759398,7288.54075 13.1619048,7288.55175 C13.1598997,7285.88921 13.1598997,7283.22967 13.1619048,7280.56914 C16.7689223,7280.01844 20.3839599,7279.50072 23.997995,7279 C24,7282.15826 23.997995,7285.31353 24,7288.47179" id="windows-[#174]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span> {{translate('downloadForWindows')}}</a>
                            <a class="btn btn-link mt-3 downloadButton" href="https://imzalayici.com/releases/latest/imzalayici-osx.pkg"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-102.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485" id="apple-[#173]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            {{translate('downloadForMacos')}}
                        </a>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ImzalayiciV1 from './ImzalayiciV1.vue'
import ImzalayiciV2 from './ImzalayiciV2.vue'

export default {
    name: 'Imzalayici',
    props: {
        autoSubmit: {
            type: Boolean,
            default: true
        },
        items: Array,   // İmzalanacak dosyalar
        identityNumber: String,  // İmzalayacak kişinin sertifikadaki kimlik numarası
        processingMessage: null, // İşlem yapılıyor, lütfen bekleyin mesajı. Dosyaların imzalanması tamamlandıktan sonra sunucuya gönderilirken gösterilmek üzere...
        showFileList: {
            default: true,
            type: Boolean
        },
        userCertificateUrl: {
            type: String,
            default: '/user/setUserCertificate'
        },
        certificateType:{
            type: String,
            default: 'NES'
        }
    },
    components: {
        ImzalayiciV1,
        ImzalayiciV2,
    },
    computed: {
        autoCompleteId(){
            return "off_" + Math.random().toString().replace('.', '');
        }
    },
    watch: {
        imzalayiciNotFound(oldVal){
           this.$emit('imzalayiciNotFound',oldVal)
        }
    },
    created() {
        this.oldLicence = window.settings.licenceOld;// process.env.VUE_APP_IMZALAYICI_LICENCE;
        this.check();
    },
    data() {
        return {
            InitData: null,
            loading: false,
            oldLicence: null, // 'mqv3r4B5wf4K66iNYwCcxszUwXOyc/MTWTGVOo4WoWa5qqyK1BCKAe8Iwf6P2EvyALHCmrTl1QM7bMEjI2sjXQ=='
            isImzalayiciV1: false,
            isImzalayiciV2: false,
            imzalayiciNotFound: false,
            isFirstTry: true,
        };
    },
    methods: {
        setLoading(isLoading){
            this.loading = isLoading;
            this.$emit('onloading', isLoading);
        },
        sign(){
            if(this.isImzalayiciV1 == true){
                this.$refs.imzalayiciv1.sign()
            }else{
                this.$refs.imzalayiciv2.sign()
            }
        },
        completed(items){
            this.$emit('completed', items)
        },
        cancel(){
            if(this.isImzalayiciV1){
                this.$refs.imzalayiciv1.cancel()
            }else if(this.isImzalayiciV2){
                this.$refs.imzalayiciv2.cancel()
            }
        },
        async check () {  // İmzalayıcı yüklü ve çalışıyor mu, versiyonu hangisi ? kontrol et
            this.imzalayiciNotFound = false
            this.setLoading(true);
            return await this.imzalayiciV1Checker().catch(() => {
                if(!this.isImzalayiciV1){
                    axios({method: 'get',
                        url: `https://imzalayici.imzalayici.com:4449/`,
                        headers: {'Content-Type': 'application/json' }
                        }).then(r => {
                            console.log("check done",r);
                            this.InitData = r.data.data;
                            this.isImzalayiciV1 = false
                            this.isImzalayiciV2 = true
                            console.log("imzalayici v2")
                            this.setLoading(false);
                        }).catch(e => { 
                            this.InitData = { Code: -1 };
                            console.log(e);
                            this.setLoading(false);
                            this.imzalayiciNotFound = true
                        })
                }
            })
            
            
            // axios({
            //     method: 'get',
            //     url: `https://imzalayici.imzalayici.com:4449/`,
            //     headers: {'Content-Type': 'application/json' }
            //     })
            // .then(r => {
            //     console.log("check done",r);
            //     this.InitData = r.data.data;
            //     this.isImzalayiciV1 = false
            //     this.isImzalayiciV2 = true
            //     console.log("imzalayici v2")
            //     this.setLoading(false);
            //     })
            // .catch(e => {
            // //     if(this.isFirstTry){
            // //         this.triggerStartApp('imzalayici://start');
            // //         this.isFirstTry = false
            // //     }
            // //     else if(!this.isFirstTry){
            // //         this.imzalayiciV1Checker()
            // //         this.InitData = { Code: -1 };
            // //         console.log(e);
            // //         this.setLoading(false);
            // //     }
                
            // })
        },
        modechange(mode){
            this.$emit('modechange', mode);
        },
        // triggerStartApp(url){
        //     document.location = url;
        //     setTimeout(() => this.check(), 7000);
        // },
        async imzalayiciV1Checker(){
            var formData = new FormData();
            formData.set('licence', this.oldLicence);
            return await axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
            .then(r => {
                this.InitData = r.data;
                this.isImzalayiciV2 = false
                this.isImzalayiciV1 = true
                this.setLoading(false);
                })
            // .catch(e => { 
            //     this.InitData = { Code: -1 };
            //     console.log(e);
            //     this.setLoading(false);
            //     this.imzalayiciNotFound = true
            // })
        }
    }
}
</script>

<style scoped>
    .spinner-container{
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    }
    .spinner {
        border-radius: 50%;
        width: 24px;
        height: 24px;
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-top-color: #0077ff;
        animation: spin 1s ease-in-out infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    .downloadButtons{
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
    .downloadButton{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        width: fit-content;
    }
</style>
